import * as React from 'react';
export const epsSvg = React.forwardRef(function epsSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M21.888 8.271C23.05 8.287 24 9.219 24 10.344c0 1.126-.95 2.073-2.112 2.089H15.58c.789-.315 1.177-.944 1.576-1.679h4.703c.247 0 .449-.175.449-.413a.437.437 0 0 0-.449-.426h-2.193c-1.182 0-2.143-.928-2.143-2.064 0-1.135.961-2.063 2.143-2.063h3.385v1.609h-3.385a.454.454 0 0 0-.449.447c0 .237.202.427.449.427zm-8.523-2.483c1.885 0 3.41 1.482 3.41 3.31 0 1.827-1.529 3.335-3.413 3.335h-1.71V16H9.946V9.103c0-1.827 1.535-3.315 3.42-3.315zm0 4.966c.948 0 1.72-.73 1.72-1.656 0-.926-.772-1.68-1.72-1.68s-1.713.754-1.713 1.68v1.656zm-8.82 1.679h4.51c-.106.594-.446 1.46-1.312 1.46H1.331C.6 13.892 0 13.297 0 12.592V6.003C0 5.3.6 4.74 1.331 4.74h6.412c.733 0 1.332.577 1.332 1.283l-.006 4.732H4.545c-.693 0-1.294-.315-1.592-.874h5.033v-.803c0-1.825-1.555-3.308-3.449-3.308-1.61 0-2.965 1.075-3.334 2.518 0 0-.1.483-.1.798 0 .315.105.793.105.793.367 1.447 1.724 2.555 3.337 2.555zm-.008-5.094c.69 0 1.291.407 1.59.932H2.948a1.859 1.859 0 0 1 1.59-.932zm2.904-4.61v.765c0 .099-.09.196-.194.196H6.178c-.104 0-.189-.097-.189-.196V2.73c0-.753-.65-1.366-1.452-1.366-.8 0-1.452.613-1.452 1.366v.764a.205.205 0 0 1-.196.196H1.821c-.105 0-.188-.097-.188-.196v-.839C1.677 1.182 2.96 0 4.538 0 6.14 0 7.44 1.222 7.44 2.73z',
    }),
  );
});
epsSvg.defaultProps = {
  height: '16',
  viewBox: '0 0 24 16',
  width: '24',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var eps = {
  category: 'paymentmethod',
  colorable: true,
  name: 'eps',
  svg: epsSvg,
};
